import React, { Component } from "react";
import {
  StyledArtBoardPreviewContainer,
  StyledArtboardPreviewDuration,
  StyledArtBoardPreviewStaticCanvasWrapper,
  StyledArtBoardPreviewTitle,
  StyledArtBoardPreviewWrapper,
  StyledEditorBottomPanel,
} from "../_components/styled/details/styleArtBoardEditor";
import TLDRSwiper from "../_components/common/TLDRSwiper";
import { connect } from "react-redux";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { setActivePage } from "../_actions/textToolbarActions";
import { isEqual } from "lodash";
import ArtBoardPreviewStaticCanvas from "./ArtBoardPreviewStaticCanvas";
import { wsAddPage } from "../_actions/webSocketAction";
import ArtBoardPreviewDropdownActions from "./ArtBoardPreviewDropdownActions";
import {
  closeBottomPanel,
  openBottomPanel,
} from "../_actions/bottomPanelActions";
import { BottomPanelViewTypes } from "../_utils/constants";
import { Button, IconButton, Tooltip, Box } from "@chakra-ui/react";
import {
  FaChevronDown,
  FaGripHorizontal,
  FaPlus,
  FaTimes,
} from "react-icons/fa";
import { checkArtboardLimit } from "../_utils/common";
import { withTranslation } from "react-i18next";

dayjs.extend(duration);

class StudioBottomPanel extends Component {
  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
  }

  onClickFullScreenPreview = () => {
    const { openBottomPanel } = this.props;
    openBottomPanel(BottomPanelViewTypes.ARTBOARDS_GRID_VIEW);
  };

  render() {
    const { pagestore, activePage, closeBottomPanel, t, canvasRef } = this.props;

    const { pages, pageIds } = pagestore;

    const swiperParams = {
      spaceBetween: 15,
      slidesPerView: "auto",
      shouldSwiperUpdate: true,
      runCallbacksOnInit: true,
      containerClass: "bottom-panel-artboard-preview-swiper-container",
      mousewheel: true,
      centeredSlides: true,
      on: {
        init: () => {
          if (
            this.swiperRef.current &&
            this.swiperRef.current.swiper &&
            activePage.id
          ) {
            this.swiperRef.current.swiper.slideTo(activePage.pageIndex);
          }
        },
      },
    };

    const previewArtBoards = pageIds.map((pageId, index) => {
      const duration = pages[pageId]?.payload?.animation?.duration;

      return (
        <StyledArtBoardPreviewWrapper key={index}>
          <StyledArtBoardPreviewContainer
            onClick={() => {
              this.props.setActivePage(pageId, index, true);
              this.swiperRef.current.swiper.slideTo(index);
            }}
          >
            <StyledArtBoardPreviewTitle location="preview-container">
              <p>{index + 1}</p>
            </StyledArtBoardPreviewTitle>
            {duration && (
              <StyledArtboardPreviewDuration>
                {dayjs.duration(duration, "seconds").format("mm:ss")}
              </StyledArtboardPreviewDuration>
            )}

            {pageId === activePage.id && (
              <Box pos="absolute" top="0" right="0" zIndex={"dropdown"}>
                <ArtBoardPreviewDropdownActions pageId={pageId} />
              </Box>
            )}
            <StyledArtBoardPreviewStaticCanvasWrapper>
              <ArtBoardPreviewStaticCanvas page={pages[pageId]} canvasRef={canvasRef}/>
            </StyledArtBoardPreviewStaticCanvasWrapper>
          </StyledArtBoardPreviewContainer>
        </StyledArtBoardPreviewWrapper>
      );
    });

    return (
      <StyledEditorBottomPanel>
        <div
          id="preview-title-bar"
          className="title-bar"
          onClick={(e) => {
            if (e.target.id === "preview-title-bar") closeBottomPanel();
          }}
        >
          <div className="title-display">
            <Button
              rightIcon={<FaChevronDown />}
              size="sm"
              variant="ghost"
              onClick={closeBottomPanel}
            >
              {t("artboard_length", { length: previewArtBoards.length })}
            </Button>
          </div>
          <div className="actions">
            <Tooltip hasArrow placement="top" label={t("arrange")}>
              <IconButton
                aria-label="icon"
                onClick={this.onClickFullScreenPreview}
                size="sm"
                variant="ghost"
                icon={<FaGripHorizontal />}
              />
            </Tooltip>
            <Tooltip hasArrow placement="top" label={t("close_panel")}>
              <IconButton
                aria-label="icon"
                onClick={closeBottomPanel}
                size="sm"
                variant="ghost"
                icon={<FaTimes />}
              />
            </Tooltip>
          </div>
        </div>
        <TLDRSwiper swiperParams={swiperParams} refs={this.swiperRef}>
          {previewArtBoards}
          <IconButton
            opacity="1 !important"
            alignSelf="center"
            isRound
            colorScheme=""
            onClick={this.onClickAddArtBoard}
            icon={<FaPlus />}
          />
        </TLDRSwiper>
      </StyledEditorBottomPanel>
    );
  }

  onClickAddArtBoard = () => {
    const { pagestore, subscription } = this.props;
    const isAvailable = checkArtboardLimit(pagestore, subscription);
    if (isAvailable) this.props.wsAddPage();
  };

  componentDidUpdate(prevProps, prevState) {
    const { activePage } = this.props;

    if (!isEqual(prevProps.activePage, this.props.activePage)) {
      if (
        this.swiperRef.current &&
        this.swiperRef.current.swiper &&
        activePage.id
      ) {
        this.swiperRef.current.swiper.slideTo(activePage.pageIndex);
      }
    }
  }
}

StudioBottomPanel.propTypes = {};

const mapStateToProps = (state) => ({
  pagestore: state.pagestore,
  activePage: state.editor.activePage,
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  wsAddPage: () => dispatch(wsAddPage()),
  setActivePage: (pageId, pageIndex, isSelected) =>
    dispatch(setActivePage(pageId, pageIndex, isSelected)),
  closeBottomPanel: () => dispatch(closeBottomPanel()),
  openBottomPanel: (panelType) => dispatch(openBottomPanel(panelType)),
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(StudioBottomPanel)
);
